import { FileSpreadsheet } from "lucide-react";
import Can from "@/components/Can";

export default function ExcelButton({ onClick, testid = "excel-btn", label = "Excel", className = "", small = false }) {
  return (
    <Can perm="download">
      <button type="button" data-testid={testid} onClick={onClick} title="Export to Excel (.xlsx)"
        className={`no-print ${small ? "h-8 px-2.5 text-[11px]" : "h-9 px-3 text-xs"} border border-emerald-300 bg-white text-emerald-800 rounded-md font-semibold uppercase tracking-wider flex items-center gap-2 hover:bg-emerald-50 ${className}`}>
        <FileSpreadsheet size={14} /> {label}
      </button>
    </Can>
  );
}
